import Vue from 'vue';
import Vuex from 'vuex';
import popupModule from './modules/popup/index';
import dateTimeModule from './modules/settings/dateTime/index';
import dropData from './modules/drop-data/index';
import alertsBus from './modules/alertsBus/index';
import user from './modules/user/index';
import mainPageModules from './modules/mainPageModules/index';
import leverages from './modules/leverages/index';
import notifications from '@whitelist/wl-old-library/store/notifications/index';
import screener from './modules/screener';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    getters: {
        isUiBlocking: (_state, getters) => getters['user/isUiBlocking'] ||
            getters['notifications/isUiBlocking']
    },
    modules: {
        popupModule,
        dateTimeModule,
        dropData,
        user,
        alertsBus,
        mainPageModules,
        leverages,
        notifications,
        screener
    }
});
